import {FeatureGroupType} from '@catcore/services/feature-group-type/feature-group-type';
import {Observable} from 'rxjs/Observable';

export interface LinkInfo {
  href: string;
}

export interface RestMetaInfo {
  self: LinkInfo;
}

export interface StatusInfo {
  code: number;
  name: string;
  _links: RestMetaInfo;
}

export interface FeatureCreateInfo {
  name: string;
  description: string;
  status: StatusInfo;
  featureTypeGroup: Partial<FeatureGroupType>;
}

export interface FeatureChilds {
  featureUnits: any[];
  featureServices: any[];
  featureGgwDevices: any[];
  featureGgwFixedRoutes: any[];
  featureGgwDynRouteTemplates: any[];
  featureEvidFunctions: any[];
  featurePorts: any[];
  featureOptionTokens: any[];
  featureAvodCatalogs: any[];
}

export interface NodeQueryParamInfo {
  resource?: string;
  parentResourceId?: string;
}

export interface Resource {
  _links: { self: any };
}

export interface ResourceHandler {
  getCurrent: () => Observable<any>;
  extractCurrent: () => any;
  load: () => void;
  loadAndGet: () => Observable<any>;
  refresh: () => void;
  save: (data: any, create?: boolean) => Observable<any>;
  isReady: () => boolean;
  delete: () => Observable<any>;
}

export interface ResourceTransactionEvent {
  ref: string;
  success: (result: any) => void;
  failure: (result: any) => void;
}

export enum FeatureExplorerAction {
  create, info,
}

export interface ResourceFormTransactionEvent {
  resourceUri: string;
  formData: any;
  success: (result: any) => void;
  failure: (result: any) => void;
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/features/types.ts